import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=4b675194"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=4b675194&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports